export const categories = [
  {
    id: 'star',
    name: '明星动向',
    icon: 'ri-user-star-line',
    count: 128,
    description: '签约、解约、恋情与合作变化，第一时间把时间线摆出来。',
  },
  {
    id: 'screen',
    name: '影视综',
    icon: 'ri-film-line',
    count: 96,
    description: '换角、剪辑争议、改档风波，台前幕后一次讲透。',
  },
  {
    id: 'music',
    name: '音乐现场',
    icon: 'ri-music-2-line',
    count: 74,
    description: '演唱会加场、版权归属、团体变动，跟着时间线听完一整首。',
  },
  {
    id: 'fandom',
    name: '饭圈舆论',
    icon: 'ri-chat-3-line',
    count: 152,
    description: '控评、打投、站子风波，复盘舆论是怎样一步步发酵的。',
  },
  {
    id: 'brand',
    name: '品牌代言',
    icon: 'ri-store-2-line',
    count: 63,
    description: '官宣、解约、物料下架，商业合作的完整链路一次看清。',
  },
  {
    id: 'backstage',
    name: '幕后揭秘',
    icon: 'ri-file-text-line',
    count: 47,
    description: '编剧、制片、场务视角的行业观察与项目复盘。',
  },
];